module.exports = __webpack_public_path__ + "img/Asahi.11039b64.png";